import * as React from "react"

const InstagramIcon = (props) => (
  <svg
    width={16}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 4.207A4.044 4.044 0 0 0 3.957 8.25 4.021 4.021 0 0 0 8 12.293a4.044 4.044 0 0 0 4.043-4.043c0-2.215-1.828-4.043-4.043-4.043Zm0 6.68A2.633 2.633 0 0 1 5.363 8.25c0-1.441 1.16-2.602 2.637-2.602a2.596 2.596 0 0 1 2.602 2.602c0 1.477-1.16 2.637-2.602 2.637Zm5.133-6.82a.945.945 0 0 0-.95-.95.945.945 0 0 0-.949.95c0 .527.422.949.95.949.527 0 .949-.422.949-.95Zm2.672.949c-.07-1.266-.352-2.391-1.266-3.305C13.625.797 12.5.516 11.234.445c-1.3-.07-5.203-.07-6.504 0-1.265.07-2.355.352-3.304 1.266C.512 2.625.23 3.75.16 5.016c-.07 1.3-.07 5.203 0 6.504.07 1.265.352 2.355 1.266 3.304.949.914 2.039 1.196 3.304 1.266 1.301.07 5.204.07 6.504 0 1.266-.07 2.391-.352 3.305-1.266.914-.949 1.195-2.039 1.266-3.304.07-1.301.07-5.204 0-6.504Zm-1.688 7.875c-.246.703-.808 1.23-1.476 1.511-1.055.422-3.516.317-4.641.317-1.16 0-3.621.105-4.64-.317a2.665 2.665 0 0 1-1.512-1.511c-.422-1.02-.317-3.48-.317-4.641 0-1.125-.105-3.586.317-4.64a2.712 2.712 0 0 1 1.511-1.477C4.38 1.71 6.84 1.816 8 1.816c1.125 0 3.586-.105 4.64.317.669.246 1.196.808 1.477 1.476.422 1.055.317 3.516.317 4.641 0 1.16.105 3.621-.317 4.64Z"
      fill="#4952E3"
    />
  </svg>
)

export default InstagramIcon
